import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_MARK_MESSAGES_AS_READ = gql`
    mutation OnboardingMarkMessagesAsRead($candidateUuid: ID!) {
        onboardingMarkMessagesAsRead(candidateUuid: $candidateUuid)
    }
`;

const useOnboardingMarkMessagesAsRead = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_MARK_MESSAGES_AS_READ);

    const markMessagesAsRead = async (candidateUuid) => {
        return mutate({
            variables: {
                candidateUuid,
            },
        });
    };

    return {
        markMessagesAsRead,
        loading,
        error,
    };
};

export default useOnboardingMarkMessagesAsRead;
